import docCookies from "../vendor/docCookies";

export class Cookiebar {
    constructor() {
        this.addEventListeners();
    }

    addEventListeners() {
        if (this.cookiebar) {
            this.show();
            this.closeCookiebarBtn.addEventListener("click", () => {
                this.setCookie();
                this.close();
            });
        }
    }

    get cookiebar() {
        return document.querySelector("#js-cookiebar") || false;
    }

    get closeCookiebarBtn() {
        return document.querySelector("#js-close-cookiebar") || false;
    }

    setCookie() {
        const name = "cookiebarDismissed";
        const val = true;
        const CurrentDate = new Date();
        const expireDate = new Date(
            CurrentDate.setMonth(CurrentDate.getMonth() + 6)
        );
        docCookies.setItem(name, val, expireDate, "/");
    }

    show() {
        if (!docCookies.getItem("cookiebarDismissed")) {
            this.cookiebar.classList.add("active");
            setTimeout(() => {
                this.cookiebar.classList.add("show");
            }, 100);
        }
    }

    close() {
        if (docCookies.getItem("cookiebarDismissed")) {
            this.cookiebar.classList.remove("show");
            setTimeout(() => {
                this.cookiebar.classList.remove("active");
            }, 200);
        } else {
            this.cookiebar.classList.add("active");
            setTimeout(() => {
                this.cookiebar.classList.remove("show");
            }, 100);
        }
    }
}
